import Link from "@/modules/LinkOrcamento/Index.vue";

export default [
  {
    path: "/orcamento/:uuid",
    component: Link,
    meta: { title: "Orçamento Digital" },
  },
];
